import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  static values = {
    exportUrl: String,
    destroyUrl: String,
    cancelUrl: String,
    forceCancelUrl: String
  }

  static targets = ["label", "stopIcon"]

  start(event) {
    event.preventDefault()

    // Disable the button immediately to prevent double-clicks
    const button = this.element.querySelector("button")
    if (button) button.disabled = true

    // Build export URL with current page params (filters, columns, sort)
    const currentUrl = new URL(window.location.href)
    const exportUrl = new URL(this.exportUrlValue, window.location.origin)

    // Copy all current search params (filters, columns, sort) to the export URL
    currentUrl.searchParams.forEach((value, key) => {
      if (key === "page") return
      exportUrl.searchParams.set(key, value)
    })

    fetch(exportUrl.toString(), {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "text/vnd.turbo-stream.html"
      }
    }).then(response => {
      if (response.ok) {
        return response.text()
      } else {
        console.error("Export request failed:", response.status)
        if (button) button.disabled = false
      }
    }).then(html => {
      if (html) {
        Turbo.renderStreamMessage(html)
      }
    }).catch(error => {
      console.error("Export request error:", error)
      if (button) button.disabled = false
    })
  }

  download(event) {
    // Let the browser follow the link for the file download (don't preventDefault)
    // Then destroy the export via Turbo Stream to revert the button to idle
    if (!this.hasDestroyUrlValue) return

    setTimeout(() => {
      fetch(this.destroyUrlValue, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "text/vnd.turbo-stream.html"
        }
      }).then(response => {
        if (response.ok) return response.text()
      }).then(html => {
        if (html) Turbo.renderStreamMessage(html)
      })
    }, 500)
  }

  retry(event) {
    event.preventDefault()
    this.start(event)
  }

  forceCancel(event) {
    event.preventDefault()
    if (!this.hasForceCancelUrlValue) return

    const button = event.currentTarget
    if (button) button.style.pointerEvents = "none"

    fetch(this.forceCancelUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "text/vnd.turbo-stream.html"
      }
    }).then(response => {
      if (response.ok) {
        return response.text()
      } else {
        console.error("Force cancel request failed:", response.status)
        if (button) button.style.pointerEvents = ""
      }
    }).then(html => {
      if (html) {
        Turbo.renderStreamMessage(html)
      }
    }).catch(error => {
      console.error("Force cancel request error:", error)
      if (button) button.style.pointerEvents = ""
    })
  }

  cancel(event) {
    event.preventDefault()
    if (!this.hasCancelUrlValue) return

    const button = event.currentTarget
    if (button) button.disabled = true

    // Flip the label to "Cancelling…" immediately so the user gets instant
    // feedback, independent of the server round-trip and the background job's
    // next checkpoint. The turbo_stream response from the cancel endpoint
    // will re-render the button in the canonical Cancelling state.
    if (this.hasLabelTarget) this.labelTarget.textContent = "Cancelling…"
    if (this.hasStopIconTarget) this.stopIconTarget.style.display = "none"

    fetch(this.cancelUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "text/vnd.turbo-stream.html"
      }
    }).then(response => {
      if (response.ok) {
        return response.text()
      } else {
        console.error("Cancel export request failed:", response.status)
        if (button) button.disabled = false
      }
    }).then(html => {
      if (html) {
        Turbo.renderStreamMessage(html)
      }
    }).catch(error => {
      console.error("Cancel export request error:", error)
      if (button) button.disabled = false
    })
  }
}
